export default __webpack_public_path__ + "static/media/forest_brook.081bdae7.png";